var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serviceTopic"},[_c('div',{staticClass:"image"}),_c('router-link',{staticClass:"veiwExample",attrs:{"to":{name: _vm.linkTo}}},[_vm._v(" 觀看相關案例 ")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"topic"},[_vm._v(_vm._s(_vm.topic))]),_c('hr'),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }